(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coord-diwali-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coord-diwali-sale')) {
    customElements.define('coord-diwali-sale', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const raw = (this.dataset.deadline || '').trim();
        const clock = this.querySelector('[data-clock]');
        const setup = this.querySelector('[data-setup]');
        const valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw);
        const end = valid ? Date.parse(raw) : NaN;
        if (!Number.isFinite(end)) {
          if (setup) setup.hidden = false;
          return;
        }
        const endLabel = this.querySelector('[data-end-label]');
        if (endLabel) endLabel.textContent = new Intl.DateTimeFormat('en-IN', {day:'numeric',month:'short',year:'numeric',hour:'numeric',minute:'2-digit',timeZone:'Asia/Kolkata',timeZoneName:'short'}).format(new Date(end));
        const update = () => {
          const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
          if (!seconds) { this.hidden = true; this.stop(); return false; }
          const values = {days:Math.floor(seconds / 86400),hours:Math.floor(seconds % 86400 / 3600),minutes:Math.floor(seconds % 3600 / 60),seconds:seconds % 60};
          for (const [unit, value] of Object.entries(values)) {
            const node = this.querySelector('[data-unit="' + unit + '"]');
            if (node) node.textContent = String(value).padStart(2, '0');
          }
          if (clock) clock.hidden = false;
          return true;
        };
        if (update()) this.interval = setInterval(update, 1000);
      }
      disconnectedCallback() { this.stop(); }
      stop() { if (this.interval) clearInterval(this.interval); this.interval = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
